import BaseAPI from './BaseAPI';

// Server-side application logging (writes to the `log` table). Currently used to
// record photo-upload failures so they can be reviewed later.
class LogAPI extends BaseAPI {
  constructor() {
    super('logs');
  }

  // POST /logs → { idlog }
  create({ type, statusCode, message, category }) {
    return this.post('', { body: { type, statusCode, message, category } });
  }
}

export const LogService = new LogAPI();
export default LogAPI;
